import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
//import { NotificationService } from './notification.service'
import * as moment from 'moment'
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  
  private behave:BehaviorSubject<Boolean> = new BehaviorSubject<Boolean>(false)
  private urlTrigger:BehaviorSubject<URLClass> = new BehaviorSubject<URLClass>(new URLClass)
  

  constructor(
    //private notifAPI:NotificationService,
    ) { }
  public async msgbox(title,msg){
    return await Swal.fire(
      title,
       msg,
      'success'
    )
  }

  public async msgboxError(title,msg){
    return await Swal.fire(
      title,
       msg,
      'error'
    )
  }
  //** HELPER Functions */
  

  

  // public async loader(msg){
  //    this.ld = await this.ldController.create({
  //       message:msg
  //    })
  //    await this.ld.present()
  // }

  // public  dismissLoader(){
  //   this.ld.dismiss()
  // }


  //Uploading Helpers
  base64toFileBlob(file){
    let blob = this.getBlob(file, ".jpg")
    const nFile = new File([blob], "image.jpg")    
    
    return nFile
  }


  private getBlob(b64Data:string, contentType:string, sliceSize:number= 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  //*************** TEMPORARY VARIABLES  */
  private _child_id_letter:string = '';

  public setChildID(c){
    this._child_id_letter = c
  }
  public getChildID(){
    return this._child_id_letter
  }

  //*************** Get Static URLS */
  public loadURLs(){
      //return this.notifAPI.getURLs()
  }

  public setURLs(data:URLClass){
    this.urlTrigger.next(data)
  }

  public getURLs(){
    return this.urlTrigger.asObservable()
  }

  //Helpers
  formatDate(dtp){
    return moment(dtp).format("MMMM DD, YYYY")
  }

  formatDateNew(dtp){
    return moment(dtp).format("YYYY-MM-DD")
  }

  getCurDate(){
    return moment().format("YYYY-MM-DD")
  }

  isNumber = value => {
    // First: Check typeof and make sure it returns number
    // This code coerces neither booleans nor strings to numbers,
    // although it would be possible to do so if desired.
    if (typeof value !== 'number') {
      return false
    }
    // Reference for typeof:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/typeof
    // Second: Check for NaN, as NaN is a number to typeof.
    // NaN is the only JavaScript value that never equals itself.
    if (value !== Number(value)) {
      return false
    }
    // Reference for NaN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN
    // Note isNaN() is a broken function, but checking for self-equality works as NaN !== NaN
    // Alternatively check for NaN using Number.isNaN(), an ES2015 feature that works how one would expect
  
    // Third: Check for Infinity and -Infinity.
    // Realistically we want finite numbers, or there was probably a division by 0 somewhere.
    // if (value === Infinity || value === !Infinity) {
    //   return false
    // }
    return true
  }

}

export class URLClass {
  img_url:       string;
  img_no_avatar: string;
  badge_url:     string;
  reward_url:    string;
}


export class ErrorClass{
   error_array: [] = [];
   error_message:string = '';
}